import React from 'react';
import Icon from '../../../components/AppIcon';

const ServiceAnalytics = ({ analytics, loading }) => {
  if (loading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        {[1, 2, 3, 4]?.map((i) => (
          <div key={i} className="bg-card border border-border rounded-lg p-6 animate-pulse">
            <div className="h-4 bg-muted rounded w-1/2 mb-2"></div>
            <div className="h-8 bg-muted rounded w-3/4"></div>
          </div>
        ))}
      </div>
    );
  }

  const totalServices = analytics?.length || 0;
  const activeServices = analytics?.filter(s => s?.isActive)?.length || 0;
  const totalCountries = analytics?.reduce((sum, s) => sum + (s?.totalCountries || 0), 0);
  const avgCoverage = totalServices > 0 
    ? (analytics?.reduce((sum, s) => sum + parseFloat(s?.coveragePercentage || 0), 0) / totalServices)?.toFixed(1)
    : 0;

  const metrics = [
    {
      label: 'Total Services',
      value: totalServices,
      icon: 'Briefcase',
      color: 'text-blue-500',
      bgColor: 'bg-blue-500/10'
    },
    {
      label: 'Services Actifs',
      value: activeServices,
      icon: 'CheckCircle',
      color: 'text-green-500',
      bgColor: 'bg-green-500/10'
    },
    {
      label: 'Pays Couverts',
      value: totalCountries,
      icon: 'Globe',
      color: 'text-purple-500',
      bgColor: 'bg-purple-500/10'
    },
    {
      label: 'Couverture Moyenne',
      value: `${avgCoverage}%`,
      icon: 'TrendingUp',
      color: 'text-orange-500',
      bgColor: 'bg-orange-500/10'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      {metrics?.map((metric, index) => (
        <div
          key={index}
          className="bg-card border border-border rounded-lg p-6 hover:shadow-md transition-shadow"
        >
          <div className="flex items-center justify-between mb-3">
            <div className={`p-3 rounded-lg ${metric?.bgColor}`}>
              <Icon name={metric?.icon} size={24} className={metric?.color} />
            </div>
          </div>
          <p className="text-sm text-muted-foreground mb-1">{metric?.label}</p>
          <p className="text-2xl font-bold text-foreground">{metric?.value}</p>
        </div>
      ))}
    </div>
  );
};

export default ServiceAnalytics;